import { ModuleFE_FHIRQuery } from './ModuleFE_FHIRQuery.js';
export const ModulePackFE_FHIRQueryDB = [ModuleFE_FHIRQuery];
//# sourceMappingURL=module-pack.js.map